{
  "title": "Media Gallery",
  "unfiled": "Unfiled",
  "tabs": {
    "gallery": "Gallery",
    "pending": "Pending"
  },
  "filters": {
    "filterBy": "Filter by",
    "lastUpdated": "Last updated",
    "dateTaken": "Date taken",
    "fromDate": "From date",
    "toDate": "To date",
    "to": "to",
    "clear": "Clear"
  },
  "albums": {
    "all": "All ({count})",
    "newFolder": "New folder",
    "newAlbum": "New album",
    "deleteFolderTitle": "Delete folder",
    "pendingPill": "{count} pending",
    "itemCount": "{count} item",
    "itemCountPlural": "{count} items",
    "emptyHeading": "No albums",
    "emptyMessageCanUpload": "Create an album to start adding photos and videos.",
    "emptyMessage": "Nothing here yet.",
    "modalEditHeading": "Edit album",
    "modalNewHeading": "New album",
    "nameLabel": "Album name",
    "nameRequired": "Album name is required",
    "folderLabel": "Folder",
    "descriptionLabel": "Description (optional)",
    "save": "Save album",
    "saved": "Album saved"
  },
  "folders": {
    "modalHeading": "New folder",
    "nameLabel": "Folder name",
    "nameRequired": "Folder name is required",
    "created": "Folder created",
    "create": "Create folder",
    "deleteHeading": "Delete folder",
    "deleteMessage": "Delete folder \"{name}\"? Its albums are kept and become Unfiled.",
    "deleteConfirm": "Delete folder"
  },
  "pending": {
    "emptyHeading": "Nothing to review",
    "emptyMessage": "Student submissions awaiting approval will appear here.",
    "unknownUploader": "Unknown",
    "approve": "Approve",
    "reject": "Reject",
    "approved": "Approved",
    "rejectHeading": "Reject submission",
    "rejectMessage": "Reject \"{name}\"? It will be deleted and the student notified. You can add a reason below.",
    "rejectConfirm": "Reject",
    "reasonPlaceholder": "Reason (optional, shared with the student)"
  },
  "type": {
    "photo": "Photo",
    "video": "Video"
  },
  "lightbox": {
    "taken": "Taken {date}",
    "awaitingApproval": "awaiting approval",
    "tags": "Tags",
    "tagPlaceholder": "Search or create a tag…",
    "openFull": "Open full",
    "download": "Download",
    "close": "Close"
  },
  "confirm": {
    "fallback": "Confirm"
  }
}
